import { createSlice, current } from '@reduxjs/toolkit';
import { createHour, updateHour, getHours, deleteHours } from '../thunks/hours';
import { mergeArrayByKey } from '../../utils/helpers/data';

export const hoursSlice = createSlice({
  name: 'hours',
  initialState: {
    hours: [],
    currentPage: 1,
    limit: 30,
    totalMinutes: 0,
    totalDocs: 0,

    isCreating: false,
    isUpdating: {},
    isFetching: false,
  },

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    }
  },

  extraReducers: {
    [getHours.pending]: (state, action) => {
      state.isFetching = true;
    },
    [getHours.fulfilled]: (state, action) => {
      const { hours, totalMinutes, totalDocs } = action.payload;

      state.totalMinutes = totalMinutes;
      state.totalDocs = totalDocs;
      
      const currentState = current(state);
      state.hours = currentState.currentPage === 1 ? [...hours] : mergeArrayByKey([...currentState.hours, ...hours], '_id');
    
      state.isFetching = false;
    },
    [getHours.rejected]: (state, action) => {
      const currentState = current(state);
      if (currentState.currentPage === 1) {
        state.hours = [];
        state.totalMinutes = 0;
        state.totalDocs = 0;
      }
      state.isFetching = false;
    },
    
    [createHour.pending]: (state, action) => {
      state.isCreating = true;
    },
    [createHour.fulfilled]: (state, action) => {
      const currentState = current(state);
      state.hours.push(action.payload);
      state.totalMinutes = currentState.totalMinutes + Number(action.payload.totalMinutes);
      state.totalDocs = currentState.totalDocs + 1;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
      state.isCreating = false;
    },
    [createHour.rejected]: (state, action) => {
      state.isCreating = false;
    },

    [updateHour.pending]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = true;
    },
    [updateHour.fulfilled]: (state, action) => {
      const currentState = current(state);
      const updatedHour = action.payload;
      const oldTotalMinutes = currentState.hours.find(hour => hour._id === updatedHour._id).totalMinutes;
      state.hours = currentState.hours.map(hour => hour._id === updatedHour._id ? updatedHour : hour);
      state.totalMinutes = currentState.totalMinutes + Number(updatedHour.totalMinutes - oldTotalMinutes);
      state.isUpdating[updatedHour._id] = false;
    },
    [updateHour.rejected]: (state, action) => {
      state.isUpdating[action.meta.arg.formData._id] = false;
    },

    [deleteHours.fulfilled]: (state, action) => {
      const currentState = current(state);
      const ids = action.payload;
      const oldTotalMinutes = currentState.hours.filter(({ _id }) => ids.includes(_id))
        .reduce((acc, hour) => acc + Number(hour.totalMinutes), 0);
      state.hours = currentState.hours.filter(({ _id }) => !ids.includes(_id));
      state.totalMinutes = currentState.totalMinutes - oldTotalMinutes;
      state.totalDocs = currentState.totalDocs - ids.length;
      state.currentPage = Math.trunc(currentState.totalDocs / currentState.limit) + 1;
    }
  }
});

export const { setCurrentPage } = hoursSlice.actions;

export default hoursSlice.reducer;
